import { customerState } from '@/src/redux/customerSlice/customerSlice';
import { RootState } from '@/src/redux/store';
import useFormatterPrice from '@/src/utils/formatter-price';
import { useFormatter, useTranslations } from 'next-intl';
import { FaCrown } from 'react-icons/fa';
import { TbCircleLetterA } from 'react-icons/tb';
import { useSelector } from 'react-redux';
import BlurredPrice from './BlurredPrice';

export default function BidHistoryListItem({
  bid,
  winning,
  showPrice = true,
}: {
  bid: any;
  winning: boolean;
  showPrice?: boolean;
}) {
  const t = useTranslations('user');
  const b = useTranslations('BidForm');
  const formatterPrice = useFormatterPrice();
  const formatter = useFormatter();
  const customer: customerState = useSelector((state: RootState) => {
    return state.customer;
  });
  let userLabel = `${t('user')} ${bid.customer_id}`;
  if (customer.id === bid.customer_id && customer.type === bid.customer_type) {
    userLabel = b('label.yourBid');
  }
  let typeIcon =
    bid.source_type === 'App\\Models\\AdAuctionAutoBid' ? (
      <span title={t('bid.auto')} className='float-right text-lg'>
        <TbCircleLetterA />
      </span>
    ) : (
      ''
    );
  if (winning) {
    typeIcon =
      bid.source_type === 'App\\Models\\AdAuctionAutoBid' ? (
        <span
          title={t('bid.auto')}
          className='float-right text-lg text-positive'
        >
          <TbCircleLetterA />
        </span>
      ) : (
        <span className='float-right text-lg text-positive'>
          <FaCrown />
        </span>
      );
  }
  const date = new Date(bid.created_at);
  return (
    <tr>
      <td>
        <span className='flex flex-wrap items-center gap-1'>{userLabel}</span>
      </td>
      <td className='text-right'>
        {('00' + date.getDate()).slice(-2)}.
        {('00' + (date.getMonth() + 1)).slice(-2)}{' '}
        {('00' + date.getHours()).slice(-2)}:
        {('00' + date.getMinutes()).slice(-2)}:
        {('00' + date.getSeconds()).slice(-2)}
      </td>
      <td className='hidden text-right sm:table-cell lg:hidden xl:table-cell'>
        {showPrice ? formatterPrice(bid.amount, process.env.NEXT_PUBLIC_DEFAULT_LOCALE) : <BlurredPrice />}
      </td>
      <td className='text-right sm:hidden lg:table-cell xl:hidden'>
        {showPrice ? formatter.number(bid.amount) : <BlurredPrice />}
      </td>
      <td>{typeIcon}</td>
    </tr>
  );
}
